import { render } from "./sandTable.vue?vue&type=template&id=721221fa"
import script from "./sandTable.vue?vue&type=script&lang=js"
export * from "./sandTable.vue?vue&type=script&lang=js"

import "./sandTable.vue?vue&type=style&index=0&id=721221fa&lang=scss"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__